import { render, staticRenderFns } from "./copyingRecords.vue?vue&type=template&id=4446940c&scoped=true&"
import script from "./copyingRecords.vue?vue&type=script&lang=js&"
export * from "./copyingRecords.vue?vue&type=script&lang=js&"
import style0 from "./copyingRecords.vue?vue&type=style&index=0&id=4446940c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446940c",
  null
  
)

export default component.exports